import { API, API_GET_ID } from "../../../Config";

export const GetSingleQuestion = (id) => {
  return API_GET_ID(API.SingleQuestion, id);
};
